
// Stop any initial scroll to a hash
window.scrollTo( 0, 0 );

// Function to scroll to a specific heading
function scrollToHash( linkHref ) {

    // Get the heading we should scroll to
    let elementToScrollTo = document.querySelector( linkHref );

    // Set a variable for the eventual scroll position
    let scrollToPosition = 0

    // Add the vertical position of the heading
    scrollToPosition += window.pageYOffset + elementToScrollTo.getBoundingClientRect().top;

    // Remove the height of the mobile header
    if ( biro_mobile_header ) {
      scrollToPosition -= biro_mobile_header.getBoundingClientRect().height;
    }

    // Remove the height of the content header
    if ( biro_page_contents_expander_header ) {
      scrollToPosition -= biro_page_contents_expander_header.getBoundingClientRect().height;
    }

    // Remove the height of the admin bar
    if ( adminBar = document.querySelector( '#wpadminbar' ) ) {
      scrollToPosition -= adminBar.getBoundingClientRect().height;
    }

    // Remove a bit more for spacing
    scrollToPosition -= 30;

    // Scroll to that point
    window.scrollTo( {
      behavior: 'smooth',
      left: 0,
      top: scrollToPosition,
    } );

}

// Add a listener for the page being loaded
window.addEventListener( 'load', function( event ) {

  // If there's a hash
  if ( window.location.hash ) {

    // Scroll to it
    scrollToHash( window.location.hash );

  }

} );

// Loop through any links that aren't in page contents nav (they're dealt with in the component js)
document.querySelectorAll( 'a[ href^="#" ]:not( .page-contents-link )' ).forEach( function( link ) {

  // Add an event listener for a click
  link.addEventListener( 'click', function( event ) {

    // Stop the link being followed so we can control the scroll
    event.preventDefault();

    // Get the href of the clicked link
    let linkHref = event.currentTarget.getAttribute( 'href' );

    // Scroll to that point
    scrollToHash( linkHref );

    // Add the URL hash
    window.history.pushState( {}, '', window.location.origin + window.location.pathname + linkHref );

  } );

} );
